import { useFormContext } from 'react-hook-form'

import { ButtonGroup, Input } from '@/components/Forms'
import { ButtonGroupOption, ButtonProps } from '@/ui/Button'
import styles from '../MechanicalInformationModal.module.scss'
import { MECHANICAL_INFORMATION_FORM_FIELDS } from '../../constant'
import { BusAuthorizedStatus } from '@/types/mechanicalInformation'

const BUTTON_PROPS: ButtonProps = {
    size: 'small',
    variant: 'outline',
}

const options: ButtonGroupOption[] = [
    {
        ...BUTTON_PROPS,
        value: BusAuthorizedStatus.BusAuthorized,
        label: 'Yes, continue',
    },
    {
        ...BUTTON_PROPS,
        value: BusAuthorizedStatus.SubstitutionRequired,
        label: 'No, substitute bus',
    },
]

export const EngineeringSolution = () => {
    const { watch, register } = useFormContext()
    const busAuthorizedStatus: BusAuthorizedStatus = watch(MECHANICAL_INFORMATION_FORM_FIELDS.busAuthorizedStatus)
    const isBusAuthorizedValueSet = typeof busAuthorizedStatus === 'string'

    return (
        <div className={styles.formItemsContainer}>
            <span className={styles.textBold}>Engineering solution</span>
            <ButtonGroup
                name={MECHANICAL_INFORMATION_FORM_FIELDS.busAuthorizedStatus}
                label="Has engineer authorized bus to continue?"
                options={options}
            />

            {isBusAuthorizedValueSet && (
                <>
                    {busAuthorizedStatus === BusAuthorizedStatus.BusAuthorized && (
                        <Input
                            label="Time cleared"
                            placeholder="Time"
                            {...register(MECHANICAL_INFORMATION_FORM_FIELDS.timeCleared)}
                        />
                    )}
                    {busAuthorizedStatus === BusAuthorizedStatus.SubstitutionRequired && (
                        <div className={styles.inputContainer}>
                            <Input
                                fullWidth
                                label="Subbed bonnet number"
                                placeholder="Bonnet number"
                                {...register(MECHANICAL_INFORMATION_FORM_FIELDS.bonnetNumber)}
                            />
                            <Input
                                fullWidth
                                label="Substitution time"
                                placeholder="Time"
                                {...register(MECHANICAL_INFORMATION_FORM_FIELDS.substitutionTime)}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    )
}
